export default __webpack_public_path__ + "static/alAboutPic-d4d472b08b7f69ef9b3f7630aefa9bff.jpg";